/**
 * @fileoverview Job CRM Contacts Page
 *
 * URL: /dashboard/jobs/:jobId/contacts
 *
 * Read-only datatable that aggregates and dedupes every contact referenced
 * on the job across the eight summarization-agent-populated tables.
 *
 * Sits between Searches and Day One in the phase sidebar (see JOB_PHASE_ITEMS
 * in `-ui.app-sidebar.tsx`). Visible to all job members.
 */

import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@cvx/_generated/dataModel";
import { ContactsView } from "@/components/jobs/phases/contacts/ContactsView";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/jobs/$jobId/contacts",
)({
  component: JobContactsPage,
});

function JobContactsPage() {
  const { jobId } = Route.useParams();
  return <ContactsView jobId={jobId as Id<"jobs">} />;
}
